import type { components } from '@joyful/openapi/types.gen'
import { formatDate } from '@joyful/utils'

type AnnouncementRolloutStrategy =
  components['schemas']['AnnouncementRolloutStrategy']

export function getAnnouncementLaunchLabel({
  formatDateOptions,
  launchDate,
  rolloutStrategy,
}: {
  formatDateOptions?: {
    shouldSkipCurrentYear?: boolean
  }
  launchDate: string | null
  rolloutStrategy: AnnouncementRolloutStrategy
}) {
  if (launchDate === null) {
    if (rolloutStrategy === 'feature_flag') {
      return `Available now`
    }

    return `Unscheduled`
  }

  return formatDate(launchDate, formatDateOptions)
}
